import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzFormModule } from 'ng-zorro-antd/form';
import { IconDefinition } from '@ant-design/icons-angular';
import { EyeInvisibleOutline, EyeFill } from '@ant-design/icons-angular/icons';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { SharedModule } from 'src/app/shared/shared.module';
const icons: IconDefinition[] = [EyeInvisibleOutline, EyeFill];
export const routes = [
  { path: '', component: LoginComponent, pathMatch: 'full' },
];

@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    FormsModule,
    NzInputModule,
    NzFormModule,
    SharedModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    NzIconModule.forChild(icons),
  ],
  exports:[LoginComponent]
})
export class LoginModule {}
